module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sightseeing_815f37.jpg";